
import { StudyGroupsApi, NotificationsApi, ToCApi, CoursesApi, UsersApi, ParticipantsApi, SubmissionsApi, MessagesApi, LessonsApi, ProjectsApi, ApiClient, GeneralApi, PostsApi, SubmissionStatisticsApi, AssessmentsApi, ApplicationsApi, LessonParticipantsApi, LocksApi } from '@skillz/lms.api.client'

function getUrl(cmd) {
    // return `${window.config.apiUrl}/api/${cmd}`
    return `${window.config.LMSApiUrl}/${cmd}`
}

export async function getJson(cmd) {
    let url = getUrl(cmd)
    let response = await fetch(
        url, {
        mode: 'cors',
        credentials: "include"
    });
    if (response.status === 200) {
        let res = await response.json()
        console.log("getJson res", res);
        return res;
    }
    else if (response.status === 401) {
        return { status: 401 }
    }
    throw `status from api ${response.status}`;
}

export async function putJson(cmd, data) {

    let url = getUrl(cmd)
    let response = await fetch(
        url, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        mode: 'cors',
        credentials: "include",
        body: JSON.stringify(data)
    });
    if (response.status === 200) {
        return response;
    } else if (response.status === 401) {

    }
    // window.location.href = "/portal/login?next=/portal/"
}

export async function postJson(cmd, data, baseUrl) {
    let url = baseUrl ? `${baseUrl}${cmd}` : getUrl(cmd)
    // alert(url)
    let response = await fetch(
        url, {
        method: 'POST',
        mode: 'cors',
        credentials: "include",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });

    if (response.ok)
        return response;
    throw response.status
}

export const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms))

export function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

const apiClient = new ApiClient(`${window.config.LMSApiUrl}`);
export const submissionsApi = new SubmissionsApi(apiClient)
export const submissionStatisticApi = new SubmissionStatisticsApi(apiClient)
export const participantsApi = new ParticipantsApi(apiClient)
export const usersApi = new UsersApi(apiClient)
export const coursesApi = new CoursesApi(apiClient)
export const ApplicationApi = new ApplicationsApi(apiClient)
export const studyGroupsApi = new StudyGroupsApi(apiClient)
export const toCApi = new ToCApi(apiClient)
export const messagesApi = new MessagesApi(apiClient)
export const notificationsApi = new NotificationsApi(apiClient)
export const lessonsApi = new LessonsApi(apiClient)
export const locksApi = new LocksApi(apiClient)
export const projectsApi = new ProjectsApi(apiClient)
export const generalApi = new GeneralApi(apiClient)
export const postsApi = new PostsApi(apiClient)
export const assessmentsApi = new AssessmentsApi(apiClient)
export const lessonParticipantsApi = new LessonParticipantsApi(apiClient)

export function getClassByNum(num) {
    let lang = localStorage.getItem("LANG");
    switch (lang) {
        case 'en':
            return ["1st", "2nd", "3rd", "4th", "5th", "6th", "7th", "8th", "9th", "10th", "11th", "12th"][num - 1];
        default:
            return ["א", "ב", "ג", "ד", "ה", "ו", "ז", "ח", "ט", "י", "יא", "יב"][num - 1];
    }
}

export function getKeyByValue(val, object) {
    const filter = Object.keys(object).filter(key => object[key] == val);
    if (filter && filter.length > 0)
        return filter[0];
    return null;
}

export const sendMessageToServiceWorker = async (action, data) => {
    if ('serviceWorker' in navigator) {
        const message = { action, data };
        try {
            const registrations = await navigator.serviceWorker.getRegistrations();
            const serviceWorker2Registration = registrations.find(registration =>
                registration.active && registration.active.scriptURL.includes('service-worker2.js')
            );
            //the message will be sent only if the service-worker is active, if sometimes its not active need to wait
            serviceWorker2Registration.active.postMessage(message);
        } catch (error) {
            console.error('Error while sending message to Service Worker:', error);
        }
    }
};

export async function notCachefetchJson(url) {
    try {
        let notCacheNumber = Math.floor(new Date().getTime());
        let res = await fetch(`${url}?ver=${notCacheNumber}`)
        if (res && res.ok) {
            const resJson = await res.json();
            return resJson;
        }
        else {
            throw new Error(`faild to fetch json url: ${url} with status: ${res && res.status}`)
        }
    }
    catch (err) {
        console.log("error in fetch json", url, err);
    }
}
